import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { LandingPageTeaser } from 'common';
import { fetchLandingPageTeaser } from './LandingPageTeaserSlice';
import { LandingPageTeaserContentSelector } from './LandingPageTeaserContentSelector';

export function useLandingPageTeaser(): AbstractContentState<LandingPageTeaser> {
    return useCmsContent(fetchLandingPageTeaser, LandingPageTeaserContentSelector);
}
